import { render } from "./ContentFooter.vue?vue&type=template&id=e1b5c5c8&ts=true"
import script from "./ContentFooter.vue?vue&type=script&lang=ts"
export * from "./ContentFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__